export default "__VITE_ASSET__Bp4s9XOj__"